module.exports = __webpack_public_path__ + "media/icons/checked_old-ecdd0832.png";